define('lq/runtimePiping',[
    'jquery',
    'lq/queryDispatcher',
    'drops/action/runtimeTypesProvider',
    'lq/dropFactory',
    'lq/parameterShell',
    'lq/parameterCollection',
    'lq/runtimeBusyIndicator',
    'lq/runtimeErrorHandler',
    'lq/formatting',
    'lq/runtimeDispatcher',
    'lq/runtimeUrl',
    'lq/conditions/conditions',
    'lq/events/eventing',
    'lq/events/eventActionFactory',
    'lq/visibility/defaultVisibility',
    'lq/datasources',
    'lq/visibility/itemVisibility',
    'lq/required',
    'lq/queryString',
    'lq/timeout'
], function ($, QueryDispatcher, runtimeTypesProvider, DropFactory, ParameterShell, ParameterCollection, RuntimeBusyIndicator, RuntimeErrorHandler, Formatting, RuntimeDispatcher, RuntimeUrl, Conditions, Eventing, EventActionFactory, DefaultVisibility, Datasources, ItemVisibility, Required, QueryString, Timeout) {
    'use strict';

    var RuntimePiping = function () {
    };

    RuntimePiping.createRoot = function (globalParameters, application, $app) {
        var piping = new RuntimePiping();
        piping.$app = $app;
        piping.$modals = $app;
        piping.application = application;
        piping.timeout = new Timeout();
        piping.busyIndicator = new RuntimeBusyIndicator($('body'));
        piping.errorHandler = new RuntimeErrorHandler(piping.busyIndicator, application, $app);
        piping.parameters = new ParameterShell(
            new ParameterCollection(),
            new ParameterCollection(globalParameters),
            new ParameterCollection()
        );
        piping.formatting = new Formatting(application.formatting, application.languageISOCode
            || navigator.userLanguage
            || navigator.language);
        piping.queryString = QueryString.initialize();
        piping.url = new RuntimeUrl(piping.queryString);
        return piping;
    };

    RuntimePiping.prototype.createChildPiping = function (actionData, actionDrop, localParameters, systemParameters, $wrapper, $view, isReloaded) {
        var piping = new RuntimePiping();

        $.extend(piping, this);

        piping.$actionWrapper = $wrapper;
        piping.$actionView = $view;
        piping.dispatcher = new RuntimeDispatcher(piping.busyIndicator, actionData.actionVersion, actionData.masterPageVersion);
        piping.actionId = actionData.id;
        piping.actionInstanceId = actionDrop.instanceId;
        piping.masterPageId = actionData.view.data.masterPageId;
        piping.embeddable = actionData.view.data.embeddable;
        piping.timeout = new Timeout();
        piping.dropFactory = new DropFactory(runtimeTypesProvider, true);
        piping.parameters = this.parameters.fork(localParameters, systemParameters);
        piping.conditions = new Conditions(actionData.conditions, piping);
        piping.eventing = new Eventing(actionData.events, piping, new EventActionFactory(actionDrop), isReloaded);
        piping.datasources = new Datasources();
        piping.visibility = new DefaultVisibility();
        piping.required = new Required();
        piping.queryDispatcher = new QueryDispatcher(piping);

        return piping;
    };

    RuntimePiping.prototype.fork = function (data, parentDrop, idOutput) {
        var childParameters = this.parameters.createChildScope(data);
        var childPiping = new RuntimePiping();
        var childQueryDispatcher = new QueryDispatcher(childPiping);

        return $.extend(
            childPiping,
            this,
            {
                visibility: new ItemVisibility(data, parentDrop),
                parameters: childParameters,
                queryDispatcher: childQueryDispatcher,
                idOfItem: data[idOutput],
                timeout: new Timeout(),
                cleanUp: function() {
                    this.visibility.cleanUp();
                    this.timeout.cleanUp();
                }
            });
    };

    RuntimePiping.prototype.cleanUp = function () {
        this.visibility.cleanUp();
        this.timeout.cleanUp();
        this.dispatcher.cleanUp();
        this.dropFactory.clearCache();
    };

    return RuntimePiping;
});
